import React, { useEffect, useRef, useState } from 'react';
import fscreen from 'fscreen';
import clsx from 'clsx';
import styles from './fullscreen.module.scss';

export const Fullscreen = ({
  isFullscreen,
  onExit,
  children,
  useFullScreenApi = true,
  showCloseButton = false,
  showWhenNotFullscreen = true,
}) => {
  const fsContainerRef = useRef();
  const [useDivFullscreen, setUseDivFullscreen] = useState(false);

  useEffect(() => {
    // We need to set isFullscreen to false when the user press esc key.
    if (useFullScreenApi && fscreen.fullscreenEnabled) {
      const handler = () => {
        if (fscreen.fullscreenElement === null) {
          onExit();
        }
      };
      fscreen.addEventListener('fullscreenchange', handler, { passive: true });
      return () => fscreen.removeEventListener('fullscreenchange', handler);
    }
  }, [useFullScreenApi, isFullscreen, onExit]);

  useEffect(() => {
    if (isFullscreen) {
      if (useFullScreenApi && fscreen.fullscreenEnabled) {
        fscreen.requestFullscreen(fsContainerRef.current);
      } else {
        setUseDivFullscreen(true);
      }
    } else {
      if (fscreen.fullscreenEnabled && fscreen.fullscreenElement) {
        fscreen.exitFullscreen();
      }
      setUseDivFullscreen(false);
    }
  }, [useFullScreenApi, isFullscreen]);

  return (
    <div
      ref={fsContainerRef}
      className={clsx(
        styles.fullscreenContainer,
        useDivFullscreen && styles.activate,
        !showWhenNotFullscreen && styles.displayNone,
        isFullscreen && styles.display
      )}
    >
      {showCloseButton && (
        <button className={styles.close} aria-label="btn" onClick={onExit}>
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.707107 14.8494C0.316582 14.4589 0.316582 13.8258 0.707107 13.4352L13.435 0.707305C13.8256 0.316781 14.4587 0.316781 14.8492 0.707305C15.2398 1.09783 15.2398 1.73099 14.8492 2.12152L2.12132 14.8494C1.7308 15.24 1.09763 15.24 0.707107 14.8494Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.707107 0.7072C0.316582 1.09772 0.316582 1.73089 0.707107 2.12141L13.435 14.8493C13.8256 15.2399 14.4587 15.2399 14.8492 14.8493C15.2398 14.4588 15.2398 13.8256 14.8492 13.4351L2.12132 0.7072C1.7308 0.316676 1.09763 0.316676 0.707107 0.7072Z"
            />
          </svg>
        </button>
      )}
      {children}
    </div>
  );
};
